import { Injector } from '@angular/core';
import { CustomRouteType } from '../custom-route';
import { DevToolsRegistry } from '../../dev-tools/dev-tools.registry';
import { arraySplitByCondition } from '@core/shared/utils';
import * as i0 from "@angular/core";
import * as i1 from "../../dev-tools/dev-tools.registry";
export let RouteManager = /*#__PURE__*/(() => {
  class RouteManager {
    constructor(debug, injector) {
      this.injector = injector;
      this.addonRoutesMap = new Map();
      this.addonSlotsMap = new Map();
      debug.exposeDebugFunction(['Router', 'Addon Routes'], () => {
        return this.addonRoutesMap;
      });
      debug.exposeDebugFunction(['Router', 'Addon-Slot Routes'], () => {
        return this.addonSlotsMap;
      });
    }
    registerRoutes(routes) {
      const [addonRoutes, otherRoutes] = arraySplitByCondition(routes, route => route._type === CustomRouteType.ADDON);
      const addonSlotRoutes = routes.filter(route => !!route.defineAddonSlot);
      if (!IS_PRODUCTION) this.validateRoutes(addonSlotRoutes, addonRoutes);
      addonRoutes.forEach(route => {
        const list = this.addonRoutesMap.get(route.useAddonSlot) || [];
        this.addonRoutesMap.set(route.useAddonSlot, [...list, route]);
      });
      addonSlotRoutes.forEach(route => {
        const list = this.addonSlotsMap.get(route.defineAddonSlot) || [];
        if (!IS_PRODUCTION && this.addonSlotsMap.has(route.defineAddonSlot)) {
          console.warn('edge case: multiple routes specify same addon slot (' + route.defineAddonSlot + ')', this.addonSlotsMap.get(route.defineAddonSlot), route);
        }
        list.push(route);
        this.addonSlotsMap.set(route.defineAddonSlot, list);
      });
      if (addonRoutes.length) this.handleNewAddonRoutes(addonRoutes);
      if (addonSlotRoutes.length) this.handleNewAddonSlotRoutes(addonSlotRoutes);
    }
    validateRoutes(addonSlotRoutes, addonRoutes) {
      if (!IS_PRODUCTION) {
        addonRoutes.forEach(route => {
          if (!route.useAddonSlot) console.warn('detected addonRoute without useAddonSlot property. must be fixed!', route);
        });
        addonSlotRoutes.forEach(route => {
          if (route.pathMatch === 'full') console.warn('routes defining an addonSlot must not use pathMatch=full!', route);
          if (!route.children && !route.loadChildren) console.warn('routes defining an addonSlot should set either children or loadChildren property! (if no default routes exist, set children to empty array.)', route);
        });
      }
    }
    // addon slot registered, check for existing addon routes
    handleNewAddonSlotRoutes(addonSlotRoutes) {
      addonSlotRoutes.forEach(slotRoute => {
        const slotId = slotRoute.defineAddonSlot;
        if (this.addonRoutesMap.has(slotId)) {
          const addonRoutes = this.addonRoutesMap.get(slotId);
          this.addAddonRoutesToSlot(addonRoutes, slotId);
        }
      });
    }
    // addon routes registered, check for existing slot route
    handleNewAddonRoutes(addonRoutes) {
      addonRoutes.forEach(addonRoute => {
        const slotId = addonRoute.useAddonSlot;
        if (this.addonSlotsMap.has(slotId)) {
          this.addAddonRoutesToSlot([addonRoute], slotId);
        }
      });
    }
    addAddonRoutesToSlot(addonRoutes, slotId) {
      const slotRoutes = this.addonSlotsMap.get(slotId);
      slotRoutes.forEach(slotRoute => {
        // temporary - deep to relative paths
        if (!IS_PRODUCTION) {
          addonRoutes.forEach(route => {
            if (route.path.includes(route.useAddonSlot)) {
              console.warn("AddonRoutes should contain paths relative to the AddonSlot. Detected an AddonRoute using a deep route: '" + route.path + "'");
            }
          });
        }
        let childRoutesProp = null;
        if (slotRoute.children) childRoutesProp = 'children';else if (slotRoute._loadedChildren) childRoutesProp = '_loadedChildren';else if (slotRoute.loadChildren) throw new Error('RouteManager cannot handle slotRoutes without loaded children (' + slotRoute.defineAddonSlot + ')');else {
          slotRoute.children = [];
          childRoutesProp = 'children';
        }
        const slotArray = slotRoute[childRoutesProp];
        slotArray.push(...addonRoutes);
        // if there is a route with path==='', it must be moved to the end of list
        // because order matters for ng router.
        const emptyPathRouteIndex = slotArray.findIndex(route => {
          return route.path === '';
        });
        if (emptyPathRouteIndex > -1) {
          slotArray.push(slotArray.splice(emptyPathRouteIndex, 1)[0]);
        }
      });
    }
    static {
      this.ɵfac = function RouteManager_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RouteManager)(i0.ɵɵinject(i1.DevToolsRegistry), i0.ɵɵinject(i0.Injector));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: RouteManager,
        factory: RouteManager.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return RouteManager;
})();